import Employee from "models/employee";

class EmployeeUtility {

    static fullName(employee?: Partial<Employee> | null, fallback = ''): string {
        if (!employee) return fallback;

        const first = employee.commonName ?? employee.firstName;
        const name = [first, employee.lastName].filter(Boolean).join(' ').trim();

        return name || fallback;
    }
}

export default EmployeeUtility;
